import { Component } from '@angular/core';

@Component({
  selector: 'app-support-resources',
  templateUrl: './support-resources.component.html',
  styleUrls: ['./support-resources.component.css']
})
export class SupportResourcesComponent {

  download(url) {
    const a = document.createElement('a')
    a.href = url
    a.download = url.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

}
